/**
 * Shared public marketing routes and labels (landing, About, Technology).
 * Keeps nav/footer paths aligned; use with `PublicSiteHeader` / `PublicSiteFooter`.
 */
export const PUBLIC_SITE_LOGO_ALT =
  'Tranzit.io — freight logistics and verification platform logo' as const;

export const PUBLIC_PRIMARY_NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/technology', label: 'Technology' },
  { to: '/about', label: 'About Us' },
] as const;

export const PUBLIC_REGISTER_PATH = '/register' as const;
export const PUBLIC_LOGIN_PATH = '/login' as const;

/** Child app — external origin (not in-app routing). */
export const PUBLIC_CARRIER_PASSPORT_URL = 'https://passport.tranzit.io' as const;
export const PUBLIC_CARRIER_PASSPORT_LABEL = 'Carrier Passport' as const;

export const PUBLIC_FOOTER_PLATFORM_LINKS = [
  { to: '/technology', label: 'Technology' },
  { to: PUBLIC_REGISTER_PATH, label: 'Register' },
  { to: PUBLIC_LOGIN_PATH, label: 'Login' },
] as const;

export const PUBLIC_FOOTER_COMPANY_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About Us' },
] as const;

export const PUBLIC_FOOTER_RESOURCES_LINKS = [{ to: '/technology', label: 'Technology' }] as const;
